module.exports = __webpack_public_path__ + "ccev-logo.06c53706.png";